import { DEFAULT_FORM_DATA, TAG_NAME } from './constants';

export const parseTag = data => {
    const tag = data?.tags.find(({ name }) => name === TAG_NAME);

    return tag?.value ? { preference: tag.value } : DEFAULT_FORM_DATA;
};

export const prepareTag = formData => ({ type: 'text', name: TAG_NAME, value: formData.preference });

